export default __webpack_public_path__ + "static/media/photo--lg--12.6bcb1b3b.jpg";